import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/dialogStyle';

const useStyles = makeStyles(styles);

const WarningDialog = ({
	title,
	children,
	message,
	onConfirm,
	onCancel,
	confirmBtnText,
	confirmBtnColor = 'danger',
	cancelBtnText,
	cancelBtnColor = 'gray',
	showIcon,
}) => {
	const classes = useStyles();

	return (
		<div>
			<SweetAlert
				warning={showIcon}
				style={{ display: 'block', marginTop: '-100px' }}
				title={title}
				onConfirm={onConfirm}
				onCancel={onCancel}
				confirmBtnCssClass={`${classes.button} ${classes[confirmBtnColor]}`}
				cancelBtnCssClass={`${classes.button} ${classes[cancelBtnColor]}`}
				confirmBtnText={confirmBtnText}
				cancelBtnText={cancelBtnText}
				closeOnClickOutside={false}
				showCancel
			>
				{message}
				{children}
			</SweetAlert>
		</div>
	);
};

export default WarningDialog;

WarningDialog.propTypes = {
	title: PropTypes.string.isRequired,
	children: PropTypes.any,
	message: PropTypes.node,
	onConfirm: PropTypes.func,
	onCancel: PropTypes.func,
	confirmBtnText: PropTypes.string,
	cancelBtnText: PropTypes.string,
	showIcon: PropTypes.bool,
};
